import React, { useContext } from "react";
import { T } from 'react-translator-component';
import { format } from "date-fns";

const PublicScheduleGrid = ({ date, times, paxs, handleHourSelected }) => {
    let filterTimes = [...times];
    const today = format(new Date(), 'yyyy-MM-dd');
    if (today == date) {
        const minHour = parseInt(format(new Date(), 'HHmm'));
        console.log('14feb ', minHour);
        filterTimes = filterTimes.map((item) => {
            const timeInt = parseInt(item.slotHour.replace(":", ""));
            console.log('14feb timeInt', timeInt)
            return {
                ...item,
                disabled: timeInt < minHour ? 1 : 0
            };
        });
    }
    return (
        <div className="py-2 w-fit mx-auto text-center mb-2">
            <div
                className="grid"
                style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(4, 1fr)`,
                    gap: "8px",
                    //justifyItems: "center",
                }}
            >
                {filterTimes && (
                    <>
                        {filterTimes.map((time, index) => {
                            // console.log(time);
                            // console.log(paxs);
                            if (time.available >= paxs) {
                                return (
                                    <button
                                        key={index}
                                        style={{ fontSize: 16, lineHeight: 1 }}
                                        className={`border bg-light rounded-lg py-3 w-full ${time.disabled && 'text-danger disabled'}`}
                                        onClick={() => {
                                            if (!time.disabled) {
                                                handleHourSelected(date, time.slotHour)
                                            }
                                        }}
                                    >
                                        {time.slotHour}<span style={{ fontSize: 10 }}>
                                            {T('general.hs-abrev') != "." ? T('general.hs-abrev') : ''}
                                        </span>
                                    </button>
                                )
                            }
                        }
                        )}
                        {filterTimes.length < 4 &&
                            Array(4 - times.length)
                                .fill(null)
                                .map((_, idx) => (
                                    <div key={`empty-${idx}`} className="invisible w-full" />
                                ))}
                    </>
                )}

            </div>
        </div>
    );
};

export default PublicScheduleGrid;
